import API from 'app/utils/apiClient';

const getContest = (contestCode) => API.get(`/story-contests/${contestCode}/`);

const postContestJoinMyStory = (contestCode, storyId) =>
  API.post(`/story-contests/${contestCode}/my-stories/${storyId}/joins/`);

const getContestJoinMyStory = (contestCode, storyId) =>
  API.get(`/story-contests/${contestCode}/my-stories/${storyId}/join/`);

const postContestComplete = (contestCode) =>
  API.post(`/story-contests/${contestCode}/event-complete/`, { type: 'JOIN' });

const getContestEvent = (contestCode) =>
  API.get(`/story-contests/${contestCode}/event/`);

const getContestStory = (contestCode, storyId) =>
  API.get(`/story-contests/${contestCode}/stories/${storyId}/`);

const postContestStoryVote = (contestCode, storyId) =>
  API.post(`/story-contests/${contestCode}/stories/${storyId}/vote/`);

const getContestRanking = (contestCode) =>
  API.get(`/story-contests/${contestCode}/ranking/`);

const getContestLeftVoteCount = (contestCode) =>
  API.get(`/story-contests/${contestCode}/vote-check/`);

const getContestStoryRemind = (contestCode, storyId) =>
  API.get(`/story-contests/${contestCode}/stories/${storyId}/vote-remind/`);

const deleteContestStoryRemind = (contestCode, storyId) =>
  API.delete(`/story-contests/${contestCode}/stories/${storyId}/vote-remind/`);

const postContestStoryRemind = (contestCode, storyId) =>
  API.post(`/story-contests/${contestCode}/stories/${storyId}/vote-reminds/`);

export default {
  getContest,
  postContestJoinMyStory,
  getContestJoinMyStory,
  postContestComplete,
  getContestEvent,
  getContestStory,
  postContestStoryVote,
  getContestRanking,
  getContestLeftVoteCount,
  getContestStoryRemind,
  deleteContestStoryRemind,
  postContestStoryRemind,
};



// WEBPACK FOOTER //
// ./src/app/apis/contest.js